import { c as _c } from "react/compiler-runtime";
import { LoadingSkeletons, ProfilChip } from "@/app/(main)/(club)/mes-clubs/[id]/components/(wanted-profiles)";
interface ListProps {
  isLoading: boolean;
  queryError: boolean;
  profils: string[];
}
export const List: React.FC<ListProps> = t0 => {
  const $ = _c(6);
  const {
    isLoading,
    queryError,
    profils
  } = t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== profils || $[2] !== queryError) {
    t1 = queryError ? <p className="text-primary">Une erreur est survenue lors du chargement des profils.</p> : isLoading ? <LoadingSkeletons /> : profils.length === 0 ? <p>Exemple: Courtier</p> : profils.map(_temp);
    $[0] = isLoading;
    $[1] = profils;
    $[2] = queryError;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="flex flex-wrap gap-2 min-h-[24px]">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(profil, index) {
  return <ProfilChip key={index} profil={profil} />;
}